var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cef701a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable-value-v2 component-variable-value--image" };
const _hoisted_2 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "component-variable-image-preview-wrapper__overlay" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "component-variable-image-preview-wrapper__controls" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-upload" }, null, -1 /* HOISTED */));
const _hoisted_8 = { class: "hover-preview-bounding-box" };
const _hoisted_9 = ["src"];
import { computed, ref, toRef, toValue } from "vue";
import { useCampaignComponentAssetStore } from "src/shared/store/campaign-component-asset";
import LoadingAnimation from "src/shared/v-components/loading-animation/LoadingAnimation.vue";
import { useBuiltComponent, useBuiltComponentVariableValue, } from "src/shared/store/component-built/composables";
import fallbackImage from "assets/image-fallback.png";
import { ElPopover } from "element-plus";
import ImagePreviewDialogTrigger from "./ImagePreviewDialogTrigger.vue";
import { useElementHoverDelay } from "src/shared/v-components/ui/popover/useElementHoverDelay";
import { LONG_HOVER_DELAY } from "src/shared/app-config";
import FileUploadZone from "src/shared/v-components/ui/file/FileUploadZone.vue";
import notificationService from "src/shared/v-components/ui/notification/notification-service";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageComponentVariableRawValue',
    props: {
        componentId: {},
        variableName: {},
        variant: {},
        modelValue: {},
        isNew: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const campaignComponentAssetStore = useCampaignComponentAssetStore();
        const props = __props;
        const emit = __emit;
        const isLoading = ref(false);
        const isString = (value) => {
            return typeof value === "string";
        };
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const campaignId = computed(() => {
            var _a;
            return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id;
        });
        const isValueDefined = computed(() => {
            return isString(props.modelValue);
        });
        const img = ref(null);
        const hasHoveredLongEnough = useElementHoverDelay(img, LONG_HOVER_DELAY);
        const showPopover = computed(() => {
            return isValueDefined.value && hasHoveredLongEnough.value;
        });
        const file = ref(null);
        const builtValue = useBuiltComponentVariableValue(toRef(props, "componentId"), toRef(props, "variableName"), toRef(props, "variant"));
        const parseAssetName = (evaluateable) => {
            return evaluateable
                .replace("spel@buildtime:context.getAsset('", "")
                .replace("').getUrl()", "");
        };
        const assetUrl = computed(() => {
            var _a;
            if (!isString(props.modelValue)) {
                return null;
            }
            if (!campaignId.value) {
                return null;
            }
            const assetName = parseAssetName(props.modelValue);
            return (_a = campaignComponentAssetStore
                .getAssetByName(campaignId.value, props.componentId, assetName)) === null || _a === void 0 ? void 0 : _a.getContentUrl();
        });
        const imageValuePreviewUrl = computed(() => {
            const assetUrlValue = toValue(assetUrl);
            const builtUrlValue = toValue(builtValue);
            if (isString(assetUrlValue)) {
                return assetUrlValue;
            }
            if (isString(builtUrlValue)) {
                return builtUrlValue;
            }
            return fallbackImage;
        });
        const uploadAssetAndSetValue = () => __awaiter(this, void 0, void 0, function* () {
            if (file.value && campaignId.value) {
                try {
                    isLoading.value = true;
                    const asset = yield campaignComponentAssetStore.saveFile(campaignId.value, props.componentId, file.value);
                    updateValue(asset);
                }
                catch (e) {
                    notificationService.error(e);
                }
                finally {
                    isLoading.value = false;
                }
            }
        });
        const updateValue = (asset) => {
            if (asset) {
                // variantValue.value = `spel@buildtime:context.getAsset('${asset.name}').getUrl()`;
                emit("update:modelValue", `spel@buildtime:context.getAsset('${asset.name}').getUrl()`);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(ElPopover), {
                    placement: "left",
                    "show-arrow": false,
                    visible: showPopover.value,
                    "popper-class": "el-popper--no-padding"
                }, {
                    reference: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "component-variable-image-preview-wrapper",
                            ref_key: "img",
                            ref: img
                        }, [
                            (isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(LoadingAnimation, {
                                        "show-loading-animation": isLoading.value,
                                        "show-success-animation": false,
                                        color: 'white'
                                    }, null, 8 /* PROPS */, ["show-loading-animation"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("img", { src: imageValuePreviewUrl.value }, null, 8 /* PROPS */, _hoisted_3),
                            _createElementVNode("span", _hoisted_4, [
                                _createElementVNode("img", {
                                    class: "downloadable-overlay",
                                    src: imageValuePreviewUrl.value
                                }, null, 8 /* PROPS */, _hoisted_5),
                                _createElementVNode("span", _hoisted_6, [
                                    (isValueDefined.value)
                                        ? (_openBlock(), _createBlock(ImagePreviewDialogTrigger, {
                                            key: 0,
                                            src: imageValuePreviewUrl.value
                                        }, null, 8 /* PROPS */, ["src"]))
                                        : _createCommentVNode("v-if", true),
                                    (!_ctx.isNew)
                                        ? (_openBlock(), _createBlock(FileUploadZone, {
                                            key: 1,
                                            file: file.value,
                                            "onUpdate:file": _cache[0] || (_cache[0] = ($event) => ((file).value = $event)),
                                            onFileUploaded: _cache[1] || (_cache[1] = ($event) => (uploadAssetAndSetValue()))
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_7
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["file"]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ], 512 /* NEED_PATCH */)
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", { src: imageValuePreviewUrl.value }, null, 8 /* PROPS */, _hoisted_9)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["visible"])
            ]));
        };
    }
});
